var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.displayObject)?_c('v-row',[_c('v-col',[_c(_vm.objects[_vm.type].component,_vm._b({tag:"component"},'component',_vm.objects[_vm.type].props,false))],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }